<template>
    <v-card
        class="plot-card pb-4"
        :class="{'disabled-card': isDisabled && type === 'plot-grid'}"
        :width="width"
    >
        <div
            v-if="top"
            class="arrow"
            :class="[arrowPosition]"
            :style="{'top': top + 'px'}"
        />
        <PlotHeader
            :data="data"
            :type="type"
            :screenProperties="screenProperties"
            @close-popup="closePopup"
            @update-widget="updateWidget"
        />
        <PlotBody
            :data="data"
            :screenProperties="screenProperties"
            :type="type"
            :cardWidth="width"
        />
        <PlotFooter
            v-if="data.link"
            :data="data"
            :type="type"
            :isDisabled="isDisabled"
            :class="{'d-flex justify-end': type === 'hotspot'}"
            @update-widget="updateWidget"
        />
    </v-card>
</template>

<script>
    import PlotBody from "@/components/plotInformation/layout/PlotBody";
    import PlotHeader from "@/components/plotInformation/layout/PlotHeader";
    import PlotFooter from "@/components/plotInformation/layout/PlotFooter";

    export default {
        name: 'PlotCard',
        components: {
            PlotBody,
            PlotHeader,
            PlotFooter
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            screenProperties: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            width: {
                type: [String, Number],
                required: true
            },
            top: {
                type: Number,
                required: false
            },
            arrowPosition: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                disabledAvailabilities: [
                    2 ,     // Unavailable 
                    4,      // Reserved
                    5       // Sold
                ]
            }
        },
        computed: {
            plotAvailabilityType() {
                if (this.$props.data.details && this.$props.type !== 'hotspot') {
                    let availability = this.getPlotDetailById('availability');
                    return availability.type;
                }
                return null;
            },
            isDisabled() {
                return this.disabledAvailabilities.includes(this.plotAvailabilityType);
            }
        },
        methods: {
            updateWidget(item) {
                this.$emit('update-widget', item);
            },
            closePopup() {
                this.$emit('close-popup');
            },
            getPlotDetailById(detailId) {
                let detail = this.$props.data.details.filter(plotDetail => plotDetail.id === detailId);
                if (detail.length)
                    return detail[0];
                else
                    return null;
            }
        }
    }
</script>


<style lang="scss">
    .v-sheet.v-card.plot-card {
        border-radius: 8px;
        &.disabled-card {
            opacity: .5;
            transition: inherit;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/PlotCard.vue